import { getRgbaText } from '@/utils';
import Spacing from '@components/atoms/Spacing';
import Typography from '@components/atoms/Typography';
import Checkbox from '@components/atoms/checkbox/Checkbox';
import { CheckboxType, ElementType } from '@components/types/\bform';
import { useState } from 'react';
import BlackWhiteInput from '../Input';
import { updateOrAddData } from '../utils';
import RequiredStar from '@/assets/required_star.svg';

interface CheckboxElementProps extends Omit<ElementType, 'data'> {
  data: CheckboxType;
}

interface CheckboxValueListProps {
  value: string;
  checked: boolean;
  id: string;
}

const CheckboxElement = ({
  data,
  colorList,
  responseData,
  setResponseData,
}: CheckboxElementProps) => {
  const [checkboxValueList, setCheckboxValueList] = useState<CheckboxValueListProps[]>(
    data.choices.map((ele) => {
      return { value: ele, checked: false, id: data.id.toString() };
    })
  );

  const [inputValue, setInputValue] = useState<string>('');

  const handleChangeInputValue = (e: React.ChangeEvent<HTMLInputElement>) => {
    setInputValue(e.target.value);

    updateOrAddData(responseData, setResponseData, {
      id: `${data.id.toString()}.other_option_response`,
      value: e.target.value,
    });
  };

  const handleCheckedCheckbox = (index: number, element: string) => {
    const updatedCheckboxValueList = checkboxValueList.map((checkbox, i) => {
      if (i === index) {
        return { ...checkbox, checked: !checkbox.checked };
      } else {
        return checkbox;
      }
    });

    updateOrAddData(
      responseData,
      setResponseData,
      {
        id: data.id.toString(),
        value: element === '기타' ? '__other_option__' : element,
      },
      true
    );

    setCheckboxValueList(updatedCheckboxValueList);
  };

  const getCheckboxChecked = (index: number, id: number, value: string) => {
    if (responseData.length === 0) {
      return checkboxValueList[index].checked;
    } else {
      if (
        responseData.filter((target) => target.id === id.toString() && target.value === value)[0]
          ?.id === id.toString()
      ) {
        return true;
      } else {
        return false;
      }
    }
  };

  return (
    <Spacing col gap={25}>
      <Spacing justifyContent="space-between" alignItems="center">
        <Spacing gap={3} alignItems="center">
          {data.required === 1 && <img src={RequiredStar} width={12} height={12} />}
          <Typography color={getRgbaText(colorList.font)} size={16} weight={700} height={26}>
            {data.question}
          </Typography>
        </Spacing>
      </Spacing>
      <Spacing col gap={10}>
        {data.choices.map((element, index) => {
          return (
            <Spacing col gap={8} key={data.id + element}>
              <Checkbox
                label={element}
                checked={getCheckboxChecked(
                  index,
                  data.id,
                  element === '기타' ? '__other_option__' : element
                )}
                color={getRgbaText(colorList.element)}
                id={data.id + 'checkbox' + element}
                onChange={() => handleCheckedCheckbox(index, element)}
                value={data.id + 'checkbox' + element}
              />
              {responseData.filter(
                (item) =>
                  item.id.includes(data.id.toString()) &&
                  (item.value === '기타' || item.value === '__other_option__')
              ).length > 0 &&
                checkboxValueList[index].value === '기타' && (
                  <BlackWhiteInput value={inputValue} onChange={handleChangeInputValue} />
                )}
            </Spacing>
          );
        })}
      </Spacing>
    </Spacing>
  );
};

export default CheckboxElement;
